import { makeStyles } from '@material-ui/core'
import { NavLink } from 'Core'
import { FeatureFlagContext } from 'Core/FeatureFlagContext'
import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './NotFound.css'
const useStyle = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
})
function NotFound() {
  const classes = useStyle()
  const history = useHistory()
  const {
    data: { viewMode }
  } = useContext(FeatureFlagContext)
  const redirectURL = viewMode === 'admin' ? '/admin/' : '/user/'

  useEffect(() => {
    if (viewMode === 'user') {
      history.replace('/user/targets')
    }
  }, [viewMode])

  if (viewMode === 'user') return null

  return (
    <div className={classes.root}>
      <h3>The Route You Are Looking For Is Not Found.</h3>
      <NavLink to={redirectURL}>Go back to Home</NavLink>
    </div>
  )
}

export default NotFound
